module.exports = __webpack_public_path__ + "img/new.d0ac77aa.png";